import { render } from "./MoreInfo.vue?vue&type=template&id=85937260"
import script from "./MoreInfo.vue?vue&type=script&lang=js"
export * from "./MoreInfo.vue?vue&type=script&lang=js"

import "./MoreInfo.vue?vue&type=style&index=0&id=85937260&lang=scss"

import exportComponent from "/home/rubb/NiwCaetano/Frontend/governance/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__